import { userProfileDoc } from '@psl/functions/firebase/refs/profileDocRef';
import {
  docDataWithId,
  memorize,
} from '@psl/functions/firebase/rxfireExtensions';
import { shareReplay } from '@psl/utils/rxExtensions';

export const userProfile$ = memorize((id: string) =>
  docDataWithId(userProfileDoc(id)).pipe(shareReplay(1)),
);
